import { Region } from '@hiwaldo/sdk';
import { storeRegion } from './store-region.util';

export function formatCurrency(
  amount: number,
  min?: number,
  max?: number
): string {
  const region = storeRegion() as any as Region;
  let formatter: Intl.NumberFormat;

  switch (region) {
    case Region.UK:
      {
        formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: min,
          maximumFractionDigits: max,
        });
      }
      break;
    case Region.EU:
      {
        formatter = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: min,
          maximumFractionDigits: max,
        });
      }
      break;
    case Region.SE:
      {
        formatter = new Intl.NumberFormat('sv-SE', {
          style: 'currency',
          currency: 'SEK',
          minimumFractionDigits: min,
          maximumFractionDigits: max,
        });
      }
      break;
    case Region.US:
    default: {
      formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: min,
        maximumFractionDigits: max,
      });
    }
  }

  return formatter.format(amount / 100);
}
